import React, { } from "react"
import { useTranslation } from "react-i18next"
import Stack from '@mui/material/Stack'
import { Container } from '@mui/system'
import { Box, Typography } from '@mui/material'
import { useFaqs } from "../hooks/useFaqs"
import { Titulo } from "../components/commons/Titulo"
import Link from '@mui/material/Link'
import Parser from 'html-react-parser'
import { useTools } from '../hooks/useTools'
import ButtonScrollToTop from '../components/commons/ButtonScrollToTop'

export function Faqs() {
    const { t } = useTranslation()
    const { listaFaqs } = useFaqs()

    //TODO pasar funcion scrool al hook para que tenga ahi toda la logica
    const scroll = (value) => {
        if (value) {
            scrollToElement("#" + quitarCaracteresExtrañosId(value))
        }
    };

    const { scrollToElement, quitarCaracteresExtrañosId } = useTools()

    return (
        <>
            <ButtonScrollToTop />
            <Stack>
                <Typography variant="h1">
                    {t("Faqs.titulo")}
                </Typography>

                {listaFaqs && (
                    <Stack marginBottom={5}>
                        <Stack>
                            {listaFaqs.map((faq, index) =>
                                <Box key={index}>
                                    <Link
                                        sx={{ cursor: "pointer" }}
                                        onClick={() => scroll(faq.pregunta)}
                                        variant="listaLink"
                                    >
                                        {(index + 1) + ". " + faq.pregunta}
                                    </Link>
                                </Box>
                            )}
                        </Stack>

                        {(listaFaqs.map((faq, index) =>
                            <Box marginTop={3} key={index} id={quitarCaracteresExtrañosId(faq.pregunta)
                            }>
                                <Typography
                                    variant="h2"
                                >
                                    {faq.pregunta}
                                </Typography>
                                <Typography
                                    variant="parrafo"
                                    component="div"
                                    sx={{
                                        marginTop: "1em",
                                        textAlign: "justify"
                                    }}
                                >
                                    {faq.respuesta ? Parser(faq.respuesta) : ""}
                                </Typography>
                            </Box>
                        ))}
                    </Stack>
                )}
            </Stack>
        </>
    )
}
